import { TItem } from '@libs/types';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { TConsumerItem } from '../../types/data';

export type TListItemProps<T = TConsumerItem> = {
    item: T;
    index: number;
    firstLetter?: string;
    addLetter?: boolean;
    isSelected?: boolean;
    setSelectedIndex?: Dispatch<SetStateAction<number | undefined>>;
};
type TListItemsProps<T> = {
    items: T[];
    renderItem: React.FC<TListItemProps<T>>;
    sortByAlphabet?: boolean;
    currentIndex?: number;
};

function getFirstLetter<T extends TItem>(item: T) {
    return item?.title?.[0]?.toUpperCase();
}

function ListItems({ items, renderItem, currentIndex, sortByAlphabet = false }: TListItemsProps<TItem>) {
    const [selectedIndex, setSelectedIndex] = useState<number | undefined>(currentIndex);

    if (items?.length > 0) {
        if (sortByAlphabet) {
            const sortedItems = [...items].sort((a, b) => a.title?.localeCompare(b?.title ?? '') ?? 0);

            return (
                <>
                    {sortedItems.map((item, index) => {
                        const firstLetter = getFirstLetter<TItem>(item);
                        const addLetter = index === 0 || firstLetter !== getFirstLetter<TItem>(sortedItems[index - 1]);
                        const isSelected = index === selectedIndex;
                        return renderItem({ item, index, firstLetter, addLetter, isSelected, setSelectedIndex });
                    })}
                </>
            );
        } else {
            return (
                <>
                    {items.map((item, index) => {
                        const isSelected = index === selectedIndex;
                        return renderItem({ item, index, isSelected, setSelectedIndex });
                    })}
                </>
            );
        }
    }
    return null;
}

export default ListItems;
